// Copyright ©️ 2026 eVolve MEP, LLC

import type { WorkOrder } from '@evolvemep/api-ts';
import { Card, Text } from '@mantine/core';

import type { ModalRegistryManagedProps } from 'components/Mantine/Modals/createModalRegistry';
import { WrappedModal } from 'components/Mantine/Modals/WrappedModal';
import { validateUserNameOrEmail } from 'helpers/userHelpers';
import { getDisplayNameWO } from 'modules/Shop/WorkOrders/WorkOrderDetail/common';
import { useWorkOrders } from 'modules/Shop/WorkOrders/WorkOrdersPage/useWorkOrders';

type Props = ModalRegistryManagedProps & {
  workOrder: WorkOrder;
  onWorkOrderActioned: () => void;
};

export const WorkOrderTransferredModal = ({ workOrder, onWorkOrderActioned, ...props }: Props) => {
  const { confirmTransfer } = useWorkOrders();

  return (
    <WrappedModal
      withCloseButton={false}
      title="Work order transfer"
      onConfirm={() => confirmTransfer(workOrder.workOrderId).then(onWorkOrderActioned)}
      withCancelButton={false}
      {...props}
    >
      <Text fz="sm">
        <b>{getDisplayNameWO(workOrder)}</b> was transferred to <b>{workOrder.facilityName}</b> with the following
        reason:
      </Text>
      <Card fz="sm" bg="gray.1" p="xs">
        <Text>{workOrder.workOrderStateComments}</Text>
      </Card>
      <Text fz="sm">
        Transferred by <b>{validateUserNameOrEmail(workOrder.workOrderStateCreatedBy)}</b>
      </Text>
    </WrappedModal>
  );
};
